import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './Components/Navbar/Navbar'; 
import Home from './pages/Home';
import Footer from './Components/Footer/Footer'; 
import PortalPage from './pages/PortalPage';
import RegistrationForm from './pages/RegistrationForm';
import PrivacyPage from './pages/PrivacyPage'; 
import TermsPage from './pages/TermsPage'; // TermsPage import kiya
import PortalButton from './Components/PortalButton/PortalButton';
import './App.css';

// Layout handle karne ke liye helper component
const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  
  // In sabhi paths par Navbar, Footer aur PortalButton hide rahega
  const hideLayoutPaths = ['/portal', '/register', '/privacy-policy', '/terms-of-service'];
  const shouldHideLayout = hideLayoutPaths.includes(location.pathname);

  return (
    <div className="App">
      {!shouldHideLayout && <Navbar />}

      {children}

      {!shouldHideLayout && (
        <>
          <Footer />
          <PortalButton />
        </>
      )}
    </div>
  );
};

function App() {
  return (
    <Router>
      <LayoutWrapper>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portal" element={<PortalPage />} />
          <Route path="/register" element={<RegistrationForm />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          
          {/* Terms of Service Route */}
          <Route path="/terms-of-service" element={<TermsPage />} />
        </Routes>
      </LayoutWrapper>
    </Router>
  );
}

export default App;